module.exports = __webpack_public_path__ + "media/images/category_icons/people-ff976b1b632132087293d5cd2d8df247.svg";